var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrthopaedic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 23.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.77,4.23h0a4.15,4.15,0,0,0-1.9-1.09,4,4,0,0,0-1.08-1.89,4.22,4.22,0,0,0-6.42,5.43L11,9a.69.69,0,0,0-.19.64l.5,2.48a.68.68,0,0,0,.55.55l2.48.5A.71.71,0,0,0,15,13l2.36-2.37a4.21,4.21,0,0,0,5.43-6.41Zm-1,5,0,0h0a2.81,2.81,0,0,1-3.93,0l0,0h0a.69.69,0,0,0-.5-.2h0a.66.66,0,0,0-.48.2l-2.56,2.56-1.66-.33-.33-1.66,2.55-2.55a.69.69,0,0,0,.21-.5.67.67,0,0,0-.21-.5,2.81,2.81,0,0,1,4-4,2.44,2.44,0,0,1,.54.77A4.27,4.27,0,0,0,16.8,4.22a.71.71,0,0,0,1,1,2.83,2.83,0,0,1,4,0h0A2.8,2.8,0,0,1,21.77,9.19Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52,7.54l-1-1a.7.7,0,0,0-1,1l1,1a.7.7,0,1,0,1-1Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,9.29H6a.7.7,0,0,0-.7.71.7.7,0,0,0,.7.7H8a.7.7,0,0,0,.7-.7A.7.7,0,0,0,8,9.29Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.34a.7.7,0,0,0-.7.71V8a.7.7,0,1,0,1.4,0v-2A.7.7,0,0,0,10,5.34Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46,16.49l-1-1a.71.71,0,1,0-1,1l1,1a.71.71,0,0,0,1,0A.69.69,0,0,0,17.46,16.49Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,15.29a.7.7,0,0,0-.7.7v2a.71.71,0,0,0,1.41,0V16A.7.7,0,0,0,14,15.29Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13.28H16a.7.7,0,1,0,0,1.4h2a.7.7,0,1,0,0-1.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.17,14.3a.72.72,0,0,0-.54-.49l-2-.41-.4-2A.7.7,0,0,0,9,11L6.66,13.36a4.22,4.22,0,1,0-3.54,7.5,4.22,4.22,0,1,0,7.52-3.53L13,15A.73.73,0,0,0,13.17,14.3Zm-4,2.49h0a.7.7,0,0,0,0,1,2.8,2.8,0,1,1-4.76,2.37,2.73,2.73,0,0,1,.78-2.37.72.72,0,0,0,0-1,.71.71,0,0,0-1,0A4.21,4.21,0,0,0,3,19.32a2.48,2.48,0,0,1-.78-.54,2.81,2.81,0,1,1,4-4,.71.71,0,0,0,1,0l1.88-1.87.24,1.2a.69.69,0,0,0,.55.55l1.19.24Z",
    transform: "translate(0 -0.01)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrthopaedic);
export default __webpack_public_path__ + "static/media/orthopaedic.661dd544ee675ee5bb32dd8d53bd9956.svg";
export { ForwardRef as ReactComponent };